"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The DatasetXAxis model module.
 * @module model/DatasetXAxis
 * @version 0.2.0
 */
var DatasetXAxis = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>DatasetXAxis</code>.
   * @alias module:model/DatasetXAxis
   */
  function DatasetXAxis() {
    _classCallCheck(this, DatasetXAxis);

    DatasetXAxis.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(DatasetXAxis, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>DatasetXAxis</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DatasetXAxis} obj Optional instance to populate.
     * @return {module:model/DatasetXAxis} The populated <code>DatasetXAxis</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new DatasetXAxis();

        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }

        if (data.hasOwnProperty('values')) {
          obj['values'] = _ApiClient["default"].convertToType(data['values'], [Object]);
        }
      }

      return obj;
    }
  }]);

  return DatasetXAxis;
}();
/**
 * @member {module:model/DatasetXAxis.TypeEnum} type
 */


DatasetXAxis.prototype['type'] = undefined;
/**
 * @member {Array.<Object>} values
 */

DatasetXAxis.prototype['values'] = undefined;
/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */

DatasetXAxis['TypeEnum'] = {
  /**
   * value: "time"
   * @const
   */
  "time": "time",

  /**
   * value: "number"
   * @const
   */
  "number": "number"
};
var _default = DatasetXAxis;
exports["default"] = _default;